import React from 'react';
import { withTranslation } from 'react-i18next/hooks';

import {Paper} from '@material-ui/core';
import { ReportMonitoringRecordingsFilter } from './ReportMonitoringRecordingsFilter';
import { ReportMonitoringRecordingsList } from './ReportMonitoringRecordingsList';
import SqlRequest from '../../../../api/sql/SqlRequest';
import { base64toGuid, getObjectByID } from '../../../../api/helpers';
import NativeTable from '../../../../api/sql/NativeTable';
import { formatDateToFileName } from '../../../../api/date';
import { RecordPlayer } from '../RecordPlayer/RecordPlayer';


class ReportMonitoringRecordingsPanel_ extends React.Component {

    constructor(props) {
        super(props)

        const time = new Date()
        const dateFrom = new Date(time.getFullYear(), time.getMonth(), time.getDate(), 0, 0 )
        const dateTo = new Date(time.getFullYear(), time.getMonth(), time.getDate()+1, 0, 0 )
        

        this.state = {
            filter: {
                dateFrom: dateFrom,
                dateTo: dateTo,
                networkID: props.networkID,
                userID: null,
                user: ''
            },
            reportData: {columns:[], rows:[]},
            player: {
                open: false,
                records: null
            }
        }

        this.handleFilterChange = this.handleFilterChange.bind(this)

        this.handleQueryComplete = this.handleQueryComplete.bind(this)

        this.handleAction = this.handleAction.bind(this)

        this.handleReportRequestComplete = this.handleReportRequestComplete.bind(this)
    }
    
    componentDidMount(){
        this.handleFilterChange(this.state.filter)
    }

    handleFilterChange(filter){
        this.setState({filter: filter})
        console.log('filter:')
        console.log(filter)
    }


    handleQueryComplete(events){
        //alert('query complete')
        console.log('handleQueryComplete')
        console.log(events)
        this.setState({events: events})
    }

    filename(row){

        let ext=''
        switch(row.media){
            case 1: ext = "mp3"; break
            
            case 33: 
            case 17: 
            case 65: ext = "mkv"; break

            default: ext = 'mp3'
        }

        let name = formatDateToFileName(row.edt) + ' (' + row.manufacturer + '-' + row.model + ').'+ext

        return name
    }

    handleAction(action){
        switch(action.type){

            case 'FILTER_CHANGE':{
                this.setState({filter: action.filter})
                break
            }
            case 'FILTER_APPLY':{
                this.applyFilter(action.filter)
                break
            }
            case 'RESOURCE_DOWNLOAD':{
                //console.log('RESOURCE_DOWNLOAD')
                //console.log(action)
                let rows = action.rows

                rows.map((row)=>{
            
                    let resourceType = row.etype //row.calltype==1 || row.calltype==3 ? 1 : 2 

                    //let filename = formatDateToFileName(row.edt) + ' (' + row.manufacturer + '-' + row.model + ').mp3'

                    this.props.onAction({
                        type: 'RESOURCE_DOWNLOAD', 
                        resourceType: resourceType, 
                        resourceID: row.euuid,
                        networkID: row.networkid,
                        filename: this.filename(row)
                    })

                })
            

                break
            }

            case 'RESOURCE_GET':{
                //console.log('RESOURCE_GET')
                //console.log(action)
                let row = action.row

                //rows.map((row)=>{

                    //let resourceType =  //row.calltype==1 || row.calltype==3 ? 1 : 2 

                    //let filename = formatDateToFileName(row.edt) + ' (' + row.manufacturer + '-' + row.model + ').mp3'
    
                    this.props.onAction({
                        type: 'RESOURCE_GET', 
                        resourceType: row.etype, 
                        resourceID: row.euuid,
                        networkID: row.networkid,
                        filename: this.filename(row),
                        onComplete: action.onComplete
                    })

                //})

                break
            }

            case 'RESOURCE_PLAY':{
                //console.log('RESOURCE_PLAY')
                //console.log(action)

                let rows = action.rows

                this.setState(  {player: {
                    open: true,
                    records: rows,
                    version: action.version
                }})

                break
            }

            case 'RESOURCE_PLAY_CLOSE':{

                this.setState(  {player: {
                    open: false,
                    records: null
                }})

                break
            }

            default: {
                console.error('Unknown action')
                console.error(action)
            }
        }
    }

    applyFilter(f){
        
        const dateFrom = f.dateFrom.getTime()
        const dateTo = f.dateTo.getTime()

        //console.log('filter')
        //console.log(f)

        //console.log('this.props')
        //console.log(this.props)

        //console.log('dateFrom')
        //console.log(dateFrom)
        //console.log('dateTo')
        //console.log(dateTo)

        let networkID = f.networkID ? f.networkID : this.props.networkID 
        
        let networkGUID = base64toGuid(networkID)

        const sqlRequest = new SqlRequest(networkID, this.handleReportRequestComplete)

        let where = ' 1=1 '

        if(f.userID){
            where += " and monitoring.sourceID ='" + base64toGuid(f.userID) + "'";
        }

        if(f.dateFrom){
            where +=  " and monitoringDetails.dt >= @p1 "
            const ext1 = sqlRequest.parameterExtension('System.DateTime', "p1", dateFrom)
            sqlRequest.addExtension("selectMonitoring", ext1)
        }
        if(f.dateTo){
            where +=  " and monitoringDetails.dt <= @p2 "
            const ext2 = sqlRequest.parameterExtension('System.DateTime', "p2", dateTo)
            sqlRequest.addExtension("selectMonitoring", ext2)
        }
        

        //let sql_ = "SELECT TOP 10000 dt, userName, CASE isDispatcher WHEN 1 THEN 'x' WHEN 0 THEN ' ' END as dispatcher, event, manufacturer, model "+
        //         "from events inner join devices on events.deviceid=devices.id "+
        //          "WHERE " + where

        let sql = "SELECT cast('"+ networkGUID +"' as uniqueidentifier) as networkid, monitoringDetails.id as euuid, " +
                  " cast(4 as bigint) as etype, " + 
                  " monitoringDetails.dt as edt, (monitoringDetails.duration / 1000) as duration, monitoringDetails.media, devices.manufacturer, devices.model "+
                  "FROM monitoringDetails INNER JOIN devices ON monitoringDetails.deviceID = devices.id " + 
                  "     INNER JOIN monitoring ON monitoring.id = monitoringDetails.monitorID " +
                  "Where " + where

        console.log(sql)

        sqlRequest.addQuery("selectMonitoring", sql)

        
        //this.api.querySql(sqlRequest)

        this.props.onAction({type: 'SQL_REQUEST', request: sqlRequest })

    }

    handleReportRequestComplete(results){

        console.log('handleReportRequestComplete')

        console.log(results)

        const data = getObjectByID('selectMonitoring', results, 'Key')

        if(!data){
            alert('data is empty')
            return
        }

        //console.log('data')
        //onsole.log(data)

        const table = new NativeTable(data.Result)

        const dataTable = table.toDataTable()

        //console.log('dataTable')
        //console.log(dataTable)

        this.setState({reportData: dataTable})

    }



    render(){

        let player = this.state.player.open ? (
            <RecordPlayer open={true} {...this.state.player} onAction={this.handleAction}></RecordPlayer>
        ) : ''

        return(
            <>
            {player}
            <Paper style={{marginBottom:16}}>
                <ReportMonitoringRecordingsFilter 
                    networks={this.props.networks} 
                    onAction={this.handleAction} 
                    onChange={this.handleFilterChange} 
                    filter={this.state.filter}/>
                <ReportMonitoringRecordingsList 
                    onAction={this.handleAction} 
                    reportData={this.state.reportData} />
            </Paper>
            </>
        )
            //eventLogger={this.props.eventLogger} filter={this.state.filter}
    }

}

export const ReportMonitoringRecordingsPanel = withTranslation()(ReportMonitoringRecordingsPanel_);